import { render, staticRenderFns } from "./MyDossiersTile.vue?vue&type=template&id=792792ef&scoped=true"
import script from "./MyDossiersTile.vue?vue&type=script&lang=ts"
export * from "./MyDossiersTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792792ef",
  null
  
)

export default component.exports